import React from "react";
import {
    AppBar,
    Box,
    Divider,
    Drawer,
    Grid,
    IconButton,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Tab,
    Tabs,
    Toolbar as ToolbarMui,
    Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { Link } from "react-router-dom";

import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ShoppingBasketOutlinedIcon from "@mui/icons-material/ShoppingBasketOutlined";
import PendingActionsOutlinedIcon from "@mui/icons-material/PendingActionsOutlined";
import ReduceCapacityOutlinedIcon from "@mui/icons-material/ReduceCapacityOutlined";
import PrivacyTipOutlinedIcon from "@mui/icons-material/PrivacyTipOutlined";

import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";

import LoadingSplash from "./commoncComponent/LoadingSplash";
import { MarketComponent } from "./MarketComponent";
import { TabPanel } from "./TabPanelComponent";
import { BasketComponent } from "./BasketComponent";
import { BottomMenu } from "./HookUtils";

import AvatarIcon from "../assets/icons/avatar.svg";
import { AVATAR_BASE_URL_API, BANNER_BASE_URL_API, BASE_URL_API } from "../Const";
import { CardShopRepository } from "../Repository/CardShopRepository";

const drawerWidth = 240;

const DrawerHeader = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: "flex-start",
}));

export class ToolbarComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            fetchedCategories: [],
            userData: null,
            banners: [],
            value: 0,
            open: false,
            // control initial render: show splash first
            loadingVisible: true,
        };
        this.loadingRef = React.createRef();
    }

    componentDidMount() {
        const token = localStorage.getItem("pwa_token");
        const headers = {
            Authorization: token ? "Bearer " + token : "",
            "Content-Type": "application/json",
        };

        // show immediately at mount (no delay)
        this.loadingRef.current?.show("درحال بارگزاری فروشگاه ها...");

        const started = Date.now();
        const minSplash = 900; // ms

        // initialize local counters quickly (no delay)
        this.setState({ cardShopCount: CardShopRepository.getAll()?.length || 0 });

        const pCats = fetch(BASE_URL_API + "category", { headers })
            .then((r) => r.json())
            .then((res) => this.setState({ fetchedCategories: res?.data || [] }))
            .catch(console.error);

        const pBanners = fetch(BASE_URL_API + "banner?type=home")
            .then((r) => r.json())
            .then((res) => this.setState({ banners: res?.data || [] }))
            .catch(console.error);

        const pUser = token
            ? fetch(BASE_URL_API + "user", { headers })
                .then((r) => r.json())
                .then((res) => {
                    if (res?.code === "200") this.setState({ userData: res.data });
                })
                .catch(console.error)
            : Promise.resolve();

        Promise.all([pCats, pBanners, pUser]).finally(() => {
            const elapsed = Date.now() - started;
            const delay = Math.max(0, minSplash - elapsed);
            // optional: brief prep message before hiding
            setTimeout(() => {
                this.loadingRef.current?.hide();
                this.setState({ loadingVisible: false });
            }, delay);
        });
    }

    handleChange = (_e, newValue) => this.setState({ value: newValue });
    handleDrawerOpen = () => this.setState({ open: true });
    handleDrawerClose = () => this.setState({ open: false });

    render() {
        const { open, fetchedCategories, value, userData, banners, loadingVisible } = this.state;

        const drawerOptions = [
            { icon: <PendingActionsOutlinedIcon />, text: "سوابق تراکنش", link: "/transaction" },
            { icon: <ShoppingBasketOutlinedIcon />, text: "سفارشات", link: "/order" },
            { icon: <ReduceCapacityOutlinedIcon />, text: "درباره ما", link: "/about-us" },
            { icon: <PrivacyTipOutlinedIcon />, text: "قوانین و مقررات", link: "/privacy-policy" },
        ];

        return (
            <>
                {/* Splash is mounted once and controlled imperatively */}
                <LoadingSplash ref={this.loadingRef} />

                {/* Only render the main UI after splash hides */}
                {!loadingVisible && (
                    <>
                        <AppBar position="static" sx={{ background: "#ffffffcc", boxShadow: "none" }}>
                            <ToolbarMui>
                                {userData ? (
                                    <IconButton edge="start" onClick={this.handleDrawerOpen} size="large">
                                        <MenuIcon sx={{ color: "#000" }} />
                                    </IconButton>
                                ) : (
                                    <IconButton
                                        edge="start"
                                        component={Link}
                                        to="/verify"
                                        size="large"
                                        sx={{ color: "#000", fontSize: 14 }}
                                    >
                                        ورود
                                    </IconButton>
                                )}

                                <ListItemText align="center"><strong style={{
                                    width: '90%',
                                    fontSize: 18,
                                    overflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    color: 'black'
                                }}>{"Hamekara"}</strong></ListItemText>

                                <IconButton component={Link} to="/search" size="large">
                                    <SearchIcon sx={{ color: "#000" }} />
                                </IconButton>
                                <IconButton size="large">
                                    {/* your own basket component (kept) */}
                                    <BasketComponent />
                                </IconButton>
                            </ToolbarMui>

                            <Tabs
                                value={value}
                                onChange={this.handleChange}
                                variant="scrollable"
                                indicatorColor="primary"
                                textColor="secondary"
                            >
                                <Tab
                                    key="-1"
                                    label="همه بازارها"
                                    sx={{ fontWeight: "bold" }} // ✅ bold text
                                />

                                {fetchedCategories.map((category) => (
                                    <Tab
                                        key={category.id}
                                        label={category.title}
                                        sx={{ fontWeight: "bold" }} // ✅ bold each tab label
                                    />
                                ))}

                            </Tabs>
                        </AppBar>

                        {/* Drawer */}
                        <Drawer
                            anchor="left"
                            open={open}
                            onClose={this.handleDrawerClose}
                            sx={{
                                "& .MuiDrawer-paper": {
                                    width: drawerWidth,
                                    direction: "rtl",
                                    right: 0,
                                    left: "auto",
                                },
                            }}
                        >
                            <DrawerHeader>
                                <IconButton onClick={this.handleDrawerClose} size="large">
                                    <ChevronLeftIcon />
                                </IconButton>
                            </DrawerHeader>

                            <Box px={2}>
                                <Grid container spacing={2} alignItems="center">
                                    <Grid item xs={3}>
                                        <img
                                            src={
                                                userData?.picture?.url
                                                    ? `${AVATAR_BASE_URL_API}${userData.picture.url}`
                                                    : AvatarIcon
                                            }
                                            alt="User Avatar"
                                            style={{ width: 48, height: 48, borderRadius: "50%" }}
                                        />
                                    </Grid>
                                    <Grid item xs={9}>
                                        <Typography variant="subtitle1" fontWeight="bold" color="green">
                                            {userData?.name}
                                        </Typography>
                                        <Typography variant="body2" color="textSecondary">
                                            {userData?.phone}
                                        </Typography>
                                        <Typography variant="body2" color="textSecondary">
                                            موجودی: {userData?.wallet}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Box>

                            <Divider sx={{ my: 2 }} />

                            <List>
                                {drawerOptions.map((item, idx) => (
                                    <ListItem button key={idx} component={Link} to={item.link}>
                                        <ListItemIcon>{item.icon}</ListItemIcon>
                                        <ListItemText primary={item.text} sx={{ textAlign: "right" }} />
                                    </ListItem>
                                ))}
                            </List>
                        </Drawer>

                        {/* Banners */}
                        <Box sx={{ px: { xs: 1, md: 2 }, pt: 1 }}>
                            <AliceCarousel
                                autoPlay
                                autoPlayInterval={2500}
                                animationDuration={1000}
                                infinite
                                touchTracking
                                disableButtonsControls
                                disableDotsControls
                            >
                                {Array.isArray(banners) && banners.length > 0
                                    ? banners.map((banner, i) => (
                                        <div key={i} align="center">
                                            <img
                                                style={{ width: "100%", objectFit: "contain", marginTop: 8, borderRadius: 12 }}
                                                src={BANNER_BASE_URL_API + banner.picture.url}
                                                alt={`banner-${i}`}
                                            />
                                        </div>
                                    ))
                                    : null}
                            </AliceCarousel>
                        </Box>

                        {/* Market tabs */}
                        <TabPanel value={value} index={0}>
                            <MarketComponent parent_category_id={-1} />
                        </TabPanel>
                        <Box
                            sx={{
                                overflowY: "hidden",  // ✅ disables vertical scroll
                                height: "100vh",      // ensures page doesn’t overflow
                            }}
                        >
                            {fetchedCategories.map((category, index) => (
                                <TabPanel key={category.id} value={value} index={index + 1}>
                                    <MarketComponent parent_category_id={category.id} />
                                </TabPanel>
                            ))}
                        </Box>



                        <BottomMenu/>

                        <Box
                            component="footer"
                            sx={{
                                backgroundColor: '#1e1e1e',
                                color: '#f1f1f1',
                                px: 3,
                                py: 4,
                                mt: 6,
                                fontSize: 14,
                                pb: "70px",
                                textAlign: 'center'
                            }}
                        >
                            <Grid container spacing={3} justifyContent="center">
                                <Grid item xs={12} sm={4}>
                                    <Typography variant="h6" sx={{fontWeight: 'bold', mb: 1}}>
                                        درباره همه کارا
                                    </Typography>
                                    <Typography variant="body2" sx={{mb: 1}}>
                                        سامانه فروشگاهی <strong>همه کارا</strong> راهکاری نوین برای مدیریت فروشگاه‌های آنلاین و
                                        آفلاین است. با امکانات ثبت سفارش، باشگاه مشتریان، گزارش‌ گیری مالی و پشتیبانی.
                                    </Typography>
                                    <a
                                        href="https://intro.hamekara.com/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{color: '#4fc3f7', textDecoration: 'none', fontWeight: 'bold'}}
                                    >
                                        معرفی کامل همه کارا
                                    </a>
                                </Grid>

                                <Grid item xs={12} sm={4}>
                                    <Typography variant="h6" sx={{fontWeight: 'bold', mb: 1}}>
                                        تماس با ما
                                    </Typography>
                                    <Typography variant="body2" sx={{mb: 0.5}}>📞 0383-228-5853</Typography>
                                    <Typography variant="body2" sx={{mb: 0.5}}>📧 thetoptraders@gmail.com</Typography>
                                    <Typography variant="body2"> 📍 ایران - شهرکرد - ساختمان علم و فناوری پردیس - طبقه سوم -
                                        واحد 305</Typography>
                                </Grid>

                                <Grid item xs={12} sm={4}
                                      sx={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>

                                    <div className="trust-badge">
                                        <a
                                            referrerPolicy="origin"
                                            target="_blank"
                                            href="https://trustseal.enamad.ir/?id=618220&Code=W86FGXOVhlD2RNWlNLWwxE5EVujECL5N"
                                        >
                                            <img
                                                referrerPolicy="origin"
                                                src="https://trustseal.enamad.ir/logo.aspx?id=618220&Code=W86FGXOVhlD2RNWlNLWwxE5EVujECL5N"
                                                alt=""
                                                style={{cursor: "pointer"}}
                                                code="W86FGXOVhlD2RNWlNLWwxE5EVujECL5N"
                                            />
                                        </a>
                                    </div>
                                </Grid>
                            </Grid>

                            <Divider sx={{my: 3, bgcolor: '#555'}}/>

                            <Typography variant="caption" sx={{color: '#aaa'}}>
                                © {new Date().getFullYear()} Hamekara.com - کلیه حقوق محفوظ است
                            </Typography>
                        </Box>

                    </>
                )}
            </>
        );
    }
}

export default ToolbarComponent;
